import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { Link } from 'react-router-dom';

interface AccessPointCardBackButtonProps {
    to: string;
}

export const AccessPointCardBackButton: React.FC<AccessPointCardBackButtonProps> = ({ to }) => (
    <Box sx={{ position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: '0.25rem', left: '1rem', zIndex: 1000 }}>
            <IconButton
                disableRipple
                edge="start"
                color="inherit"
                aria-label="back"
                to={to}
                component={Link}
                sx={{
                    color: 'white',
                    borderRadius: 0,
                    borderBottomRightRadius: '20%',
                }}
            >
                <ArrowBackIosOutlinedIcon />
            </IconButton>
        </Box>
    </Box>
);
